import { isPixiesetAuthEnabled } from "./measurement/feature-flag"

export const getSupportEmail = (): string => {
	return isPixiesetAuthEnabled() ? "support@pixieset.com" : "next@polarr.com"
}
